import React, { Component } from 'react'
import { Dropdown } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

class RetencionMoreActions extends Component {

  handleOnCancelActionClick = () => {
    this.props.onCancelRequest();
  }

  render() {
    return (
      <Dropdown alignRight={ true }>
        <Dropdown.Toggle variant="secondary" id="dropdown-basic">
          Más { ' ' }
        </Dropdown.Toggle>

        <Dropdown.Menu>
        { Guardian.allows('retencion.cancelar') && (
          <Dropdown.Item as="div" onClick={ this.handleOnCancelActionClick }>
            Cancelar
          </Dropdown.Item>
        )}
          {/* <Dropdown.Item as="div">
            Enviar por email
          </Dropdown.Item> */}
        </Dropdown.Menu>
      </Dropdown>
    )
  }
}

export default RetencionMoreActions;